import { getToken } from "./user-service";
import axios from "axios";

/**
 * Get timeline flights
 *
 * @param {Object} params - Query parameters
 * @param {string} params.iata - Airport IATA code
 * @param {string} params.startDate - Start datetime in YYYY-MM-DDTHH:mm:ss format
 * @param {string} params.endDate - End datetime in YYYY-MM-DDTHH:mm:ss format
 * @param {string} params.type - Type filter: 'all', 'inbound', or 'outbound' (optional)
 * @param {boolean} params.groupByTime - If true, returns time-based dictionary instead of array (optional)
 * @param {boolean} params.thirtyMinLayout - If true, uses 30-minute time slots (optional, only applies when groupByTime is true)
 * @returns {Promise<Array|Object>} Array of flights or time-based dictionary
 */
export const getTimelineFlights = async (params) => {
    const token = await getToken();

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // Build query string
    const queryParams = new URLSearchParams({
        iata: params.iata,
        startDate: params.startDate,
        endDate: params.endDate,
    });

    if (params.type) {
        queryParams.append('type', params.type);
    }

    if (params.groupByTime !== undefined) {
        queryParams.append('groupByTime', String(params.groupByTime));
    }

    if (params.thirtyMinLayout !== undefined) {
        queryParams.append('thirtyMinLayout', String(params.thirtyMinLayout));
    }

    if (params.boardingFlights !== undefined) {
        queryParams.append('boardingFlights', String(params.boardingFlights));
    }

    if (params.rampTasks !== undefined) {
        queryParams.append('rampTasks', params.rampTasks);
    }

    if (params.selectedAirportArea !== undefined) {
        queryParams.append('selectedAirportArea', params.selectedAirportArea);
    }

    if (params.showAllFlights !== undefined) {
        queryParams.append('showAllFlights', params.showAllFlights);
    }

    if (params.jobsType !== undefined) {
        queryParams.append('jobsType', params.jobsType);
    }

    queryParams.append('timeZone', timezone);
    if (params.holdingArea !== undefined) {
        queryParams.append('holdingArea', params.holdingArea);
    }
    if (params.holdingLocation !== undefined) {
        queryParams.append('holdingLocation', params.holdingLocation);
    }
    if (params.rampForAllLocs !== undefined) {
        queryParams.append('rampForAllLocs', params.rampForAllLocs);
    }
    if (params.rampForHCAndHS !== undefined) {
        queryParams.append('rampForHCAndHS', params.rampForHCAndHS);
    }
    // API Gateway routes /api/v1/flights to prm-flights-service
    // prm-flights-service has /timeline-flights route registered
    const url = `/api/v1/flights/timeline-flights?${queryParams.toString()}`;

    return new Promise(async (resolve, reject) => {
        try {
            const response = await axios.get(url, {
                headers: { "Firebase-UID": token },
            });

            if (response.status >= 400 && response.status < 600) {
                throw new Error("Issue getting timeline flights");
            }

            resolve(response.data);
        } catch (e) {
            reject(new Error("error getting timeline flights"));
        }
    });
};

